import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function FleetThree() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div className={`fleetThree ${isVisible ? "visible" : ""}`}>
        <h1 className={`${isVisible ? "visible" : ""}`}>
        {t("fleet_three_title_a")} <span>{t("fleet_three_title_span1")}</span> {t("fleet_three_title_b")} <span>{t("fleet_three_title_span2")}</span> {t("fleet_three_title_c")}
        </h1>
        <p className={`${isVisible ? "visible" : ""}`}>
          {t("fleet_three_text")}
        </p>
      </div>
    </VisibilitySensor>
  );
}
export default FleetThree;
